import get from 'transmute/get';
import { ORIGINATING_TICKET_ID, SPLIT_TICKET_CREATION_TIMESTAMP, SPLIT_TICKET_ID } from '../constants/keyPaths';
export const getOriginatingTicketId = get(ORIGINATING_TICKET_ID);
export const getSplitTicketId = get(SPLIT_TICKET_ID);
export const getSplitTicketTimestamp = get(SPLIT_TICKET_CREATION_TIMESTAMP);